module.exports = __webpack_public_path__ + "static/media/ic_server_off.402f93e4.svg";